module.exports = __webpack_public_path__ + "img/8.2f685143.png";